import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=27d2d544&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=27d2d544&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../空降-sp-弯弯介绍的/kj-德语-源码/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d2d544",
  null
  
)

export default component.exports